import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import RadioButtonsGroup from '../../../../components/form/RadioButtonGroup';

const useStyles = makeStyles(() => ({
  section: {
    marginTop: 15,
  },
}));

const Religion = (props) => {
  const {handleStepState, form} = props;
  const stepSlug = 'religion';
  const classes = useStyles();

  const handleChange = event => handleStepState(stepSlug, {[event.target.name]: event.target.value});

  return (
    <div className={classes.section}>
      <Typography component='h2' variant='h2'>
        Religion or belief
      </Typography>
      <RadioButtonsGroup
        label='What is your religion?'
        showError={form[stepSlug].errors && (form[stepSlug].errors.includes('religiousBelief'))}
        errorMsg={'If you do not wish to answer this question, please select ‘Prefer not to say’'}
        name='religiousBelief'
        options={[
          {id: 'noReligion', name: 'No Religion'},
          {id: 'buddhist', name: 'Buddhist'},
          {id: 'christian', name: 'Christian (including Church of England, Catholic, Protestant and all other Christian denominations)'},
          {id: 'hindu', name: 'Hindu'},
          {id: 'jewish', name: 'Jewish'},
          {id: 'muslim', name: 'Muslim'},
          {id: 'pagan', name: 'Pagan'},
          {id: 'sikh', name: 'Sikh'},
          {id: 'other', name: 'Any other religion'},
          {id: 'preferNotToSay', name: 'Prefer not to say'}
        ]}
        value={form[stepSlug].data.religiousBelief}
        handleChange={(e) => handleChange(e)}
      />
    </div>
  );
};
Religion.propTypes = {
  handleStepState: PropTypes.func,
  form: PropTypes.object,
  step: PropTypes.object,
};

export default Religion;
